import React from 'react';

import { Button, YatTile } from '@pkg/components';
import { useToastStore } from '@pkg/components/Toast/useToastStore';
import YatHandLoader from '@pkg/components/YatHandLoader';

import { NftMintSteps } from '@app/client';
import { useEmojisStore } from '@app/store/zustand/emojis/useEmojisStore';

import { BoldText, StepContent, Text, Title } from '../YatMintFlow.style';

import { LoaderHolder, StepContentWrapper, StepWrapper, YatTileWrapper } from './MintingSteps.style';

export function NotVisualized({ currentStep }: { currentStep: NftMintSteps }) {
    const { addToast } = useToastStore();
    const { visualizerUrl, currentEmoji, currentRhythmScore } = useEmojisStore();

    function handleVisualizerClick() {
        if (visualizerUrl) {
            window.location.href = visualizerUrl;
        } else {
            addToast({ message: 'Could not launch Visualizer', minimal: true });
        }
    }

    const visualizeMarkup =
        currentStep === NftMintSteps.YatNotVisualized ? (
            <StepWrapper>
                <YatTileWrapper>
                    <YatTile
                        forceSprite
                        yat={currentEmoji}
                        rhythmScore={currentRhythmScore}
                        showRhythmScore={false}
                        glow
                    />
                </YatTileWrapper>
                <StepContentWrapper>
                    <Title>Before you mint your Yat, you need to create a custom visualization</Title>
                    <Text>
                        Yats are all about self-expression. Use the Yat Visualizer to create a stunningly beautiful
                        custom visualization for your Yat
                    </Text>
                </StepContentWrapper>
                <Button onClick={handleVisualizerClick}>Launch Visualizer</Button>
            </StepWrapper>
        ) : null;

    const processingMarkup =
        currentStep === NftMintSteps.Processing ? (
            <StepWrapper>
                <StepContentWrapper>
                    <LoaderHolder>
                        <YatHandLoader />
                    </LoaderHolder>
                    <BoldText>
                        Your shiny new visualization is in final processing to get it ready to mint. This process could
                        take 10-20 minutes, please check back soon!
                    </BoldText>
                </StepContentWrapper>
            </StepWrapper>
        ) : null;

    return (
        <StepContent>
            {visualizeMarkup}
            {processingMarkup}
        </StepContent>
    );
}
